var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-tooltip',{attrs:{"label":_vm.tip,"multilined":"","type":"is-dark"}},[_c('MiniStackVanila',{attrs:{"w":250,"colors":_vm.defColors,"values":_vm.values}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }